import { Controller } from "stimulus"

// #1719 (Sam): het venster "Kopiëren naar andere sporter" onderaan de
// schema-editor. Zoeken filtert de lijst op naam (de keuzes blijven staan),
// de teller laat zien hoeveel sporters gekozen zijn en Kopiëren werkt pas
// met minstens één sporter. Escape of een klik naast het venster sluit het.
export default class extends Controller {
  static targets = ["dialog", "zoek", "sporter", "geen", "teller", "knop"]

  open(event) {
    event?.preventDefault()
    this.element.closest(".se")?.querySelectorAll("details[open]").forEach((menu) => menu.removeAttribute("open"))
    this.dialogTarget.showModal()
    if (this.hasZoekTarget) this.zoekTarget.focus()
    this.tel()
  }

  sluit(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }

  achtergrond(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  zoek() {
    const term = this.zoekTarget.value.trim().toLowerCase()
    let zichtbaar = 0
    this.sporterTargets.forEach((rij) => {
      const past = term === "" || rij.dataset.naam.includes(term)
      rij.hidden = !past
      if (past) zichtbaar += 1
    })
    if (this.hasGeenTarget) this.geenTarget.hidden = zichtbaar > 0
  }

  tel() {
    const aantal = this.sporterTargets.filter((rij) => rij.querySelector("input").checked).length
    if (this.hasTellerTarget) {
      const t = this.tellerTarget.dataset
      const tekst = aantal === 0 ? t.zero : aantal === 1 ? t.one : t.other.replace("%{count}", aantal)
      this.tellerTarget.textContent = tekst
    }
    this.knopTarget.disabled = aantal === 0
  }
}
